module.exports = __webpack_public_path__ + "img/classroom.207af25a.png";